var $ = global.jQuery = global.$;

var Field = require('./Field');

/**
 * Generates a basic custom select box
 * @class
 * @extends Field
 */
var CustomSelect = Field.extend(
  /** @lends CustomSelect.prototype */
  {
  /**
   * Initialises the widget
   * @private
   */
  init: function() {
    var self = this;
    var block = this.$el.attr('class');

    //Call the Field widgets own init method first
    this._super();

    this.$selectValue = $('<div class="' + block + '__value"></div>');
    this.$selectArrow = $('<div class="' + block + '__arrow"></div>');

    this.$el.append(this.$selectValue);
    this.$el.append(this.$selectArrow);

    this.$select = this.$el.find('select');
    this.setFakeValue();

    this.$select.on('input change', this.setFakeValue.bind(this));
  },
  /**
   * Set/update the 'fake' value of the select
   */
  setFakeValue: function() {
    var selectedText = this.$select.children('option:selected').text();
    this.$selectValue.text(selectedText);
  }
});

module.exports = CustomSelect;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/CustomSelect.js
// module id = 118
// module chunks = 0